import { useEffect } from "react";

import { useFeatureIslandCategoryContext } from "@/components/features/_layouts/island/main-with-category/context";

/**
 * カテゴリサイドメニューの赤丸表示を制御するhook
 * バリデーションエラーがある場合に赤丸を表示する
 */
export const useErrorQuestionIndicator = (questionTitle: string, hasError: boolean) => {
	const addErrorQuestionTitle = useFeatureIslandCategoryContext((state) => state.addErrorQuestionTitle);
	const removeErrorQuestionTitle = useFeatureIslandCategoryContext((state) => state.removeErrorQuestionTitle);

	useEffect(() => {
		if (hasError) {
			addErrorQuestionTitle(questionTitle);
		} else {
			removeErrorQuestionTitle(questionTitle);
		}
	}, [hasError, questionTitle, addErrorQuestionTitle, removeErrorQuestionTitle]);
};
